import axiosInstance from "../../axiosInstance";

export const createContribution = async (contributionData, id = null) => {
  try {
    const url = id
      ? `/api/v1/speakers/contributions/${id}` // تعديل
      : `/api/v1/speakers/contributions`;     // إنشاء جديد

    const method = id ? 'put' : 'post';

    const response = await axiosInstance[method](url, contributionData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error:', error.response?.data || error.message);
    throw error;
  }
};




export const getContributions = async (page = 1, pageSize = 10) => {
  try {
    const response = await axiosInstance.get("/api/v1/speakers/contributions", {
      params: {
        Page: page,
        PageCount: pageSize,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getContribution = async (contributionId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/speakers/contributions/${contributionId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateContribution = async (formData) => {
  try {
    const id = formData.get("id"); // الحصول على ID من formData
    if (!id) {
      throw new Error("Missing ID in the formData");
    }

    const response = await axiosInstance.put(
      `/api/v1/speakers/contributions/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Axios Error Response:", error.response);
      console.error("Error details:", error.response.data);
    } else {
      console.error("Error:", error.message);
    }
    throw error;
  }
};







export const deleteContribution = async (contributionId) => {
  try {
    const response = await axiosInstance.delete(
      `/api/v1/speakers/contributions/${contributionId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
